<script>
import { mapGetters } from 'vuex'
import FooterLogo from './FooterLogo.vue'
export default {
  components: { FooterLogo },
  data: () => ({
    showDialog: false,
    devStage: window.config.VUE_APP_STAGE !== 'PROD'
  }),
  computed: {
    ...mapGetters(['locale', 'isAuthenticated', 'jwt'])
    // height: function () {
    //   return this.$vuetify.breakpoint.mdAndDown
    //     ? 'mobile-height'
    //     : 'normal-height'
    // }
  },

  methods: {
    copyJwtToClipboard(withBearer) {
      navigator.clipboard.writeText((withBearer ? 'Bearer ' : '') + this.jwt)
    }
  }
}
</script>
<template>
  <section id="footer">
    <!--  <section id="footer" :class="height">-->
    <v-dialog v-model="showDialog" :max-width="500">
      <v-card>
        <DialogBaseColoredTitle>{{
          $t('navigation.footer.contact')
        }}</DialogBaseColoredTitle>
        <v-divider></v-divider>
        <DialogBaseText class="text-center">
          <v-row>
            <v-col>{{ $t('navigation.footer.contact.content') }}</v-col>
          </v-row>
          <v-row>
            <v-col>{{ $t('navigation.footer.contact.phone') }}</v-col>
          </v-row>
          <v-row>
            <v-col><p v-html="$t('navigation.footer.contact.mail')" /></v-col>
          </v-row>
          <v-divider></v-divider>
        </DialogBaseText>
        <DialogBaseActions>
          <v-btn
            id="contactBtn"
            class="text-center px-8"
            color="primary"
            @click="showDialog = false"
          >
            {{ $t('button.close') }}</v-btn
          >
        </DialogBaseActions>
      </v-card>
    </v-dialog>
    <v-footer color="primary">
      <v-row justify="center" align="center">
        <v-col cols="auto" class="mr-auto pl-md-12">
          <v-row justify="center" align="center">
            <v-col cols="auto" class="pt-0 pb-0"><FooterLogo /></v-col>
            <v-col cols="auto">
              <v-btn
                id="aboutBtn"
                :href="$t('navigation.footer.about.us.link')"
                target="_blank"
                color="secondary"
                text
              >
                {{ $t('navigation.footer.about.us') }}</v-btn
              ></v-col
            >
            <v-col cols="12" sm="auto" align="center">
              <v-btn
                id="contact"
                color="secondary"
                text
                @click="showDialog = true"
                >{{ $t('navigation.footer.contact') }}</v-btn
              >
            </v-col>
            <v-col cols="12" sm="auto" align="center">
              <v-btn
                id="agbBtn"
                :href="$t('navigation.footer.agb.link')"
                target="_blank"
                color="secondary"
                text
              >
                {{ $t('navigation.footer.agb') }}</v-btn
              >
            </v-col>
            <v-col cols="12" sm="auto" align="center">
              <v-btn
                id="privacyBtn"
                :href="$t('navigation.footer.privacy.link')"
                target="_blank"
                color="secondary"
                text
              >
                {{ $t('navigation.footer.privacy') }}</v-btn
              >
            </v-col>
            <v-col cols="12" sm="auto" align="center">
              <v-btn
                id="imprintBtn"
                :href="$t('navigation.footer.imprint.link')"
                target="_blank"
                color="secondary"
                text
              >
                {{ $t('navigation.footer.imprint') }}</v-btn
              >
            </v-col>
            <v-col cols="12" sm="auto" align="center">
              <v-btn
                id="cookielink"
                href="javascript:Cookiebot.renew()"
                color="secondary"
                text
              >
                {{ $t('navigation.footer.cookie.link') }}</v-btn
              >
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="auto" class="pr-md-12">
          <v-row align="center" justify="center">
            <v-card
              v-if="devStage && isAuthenticated"
              color="secondary"
              elevation="5"
              outlined
            >
              <v-col cols="12" lg="auto">
                <v-btn text @click="$store.dispatch('refreshToken')"
                  >JWT-Refresh</v-btn
                >
                <v-btn text @click="copyJwtToClipboard(true)">JWT-Bearer</v-btn>
                <v-btn text @click="copyJwtToClipboard(false)">JWT-Token</v-btn>
              </v-col>
            </v-card>
            <v-img
              height="50"
              width="200"
              src="@/assets/img/png/logobox.png"
              class="ml-auto mr-auto ml-md-auto"
              contain
            ></v-img>
          </v-row>
        </v-col>
      </v-row>
    </v-footer>
  </section>
</template>
<style scoped lang="scss">
/*.mobile-height {
  height: 80px;
}
.normal-height {
  height: 45px;
}*/
.v-footer {
  img {
    vertical-align: middle;
    border-style: none;
  }
  a {
    text-decoration: none;
  }
  .v-btn {
    color: #ffffff !important;
    font-size: 1rem;
    height: 100% !important;
    .--active::before,
    &:before {
      display: none;
    }
    &:hover {
      color: var(--v-primary) !important;
    }
  }
}
</style>
